// InvoiceItem Component

/* eslint indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import app from '../../../app.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'

class InvoiceItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bExpand: false
    }
  }

  static get propTypes () {
    return {
      invoice: PropTypes.object,
      onClick: PropTypes.func,
      onSetting: PropTypes.func,
      onView: PropTypes.func,
      onDownload: PropTypes.func,
      bShowReminder: PropTypes.bool,
      isQuickbookConnected: PropTypes.bool,
      onResendMail: PropTypes.func,
      downloadUrl: PropTypes.string,
      showProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      invoice: null,
      onClick: null,
      onSetting: null,
      onView: null,
      onDownload: null,
      bShowReminder: false,
      isQuickbookConnected: false,
      onResendMail: null,
      downloadUrl: '',
      showProjectNumber: false
    }
  }

  render () {
    const { invoice, showProjectNumber, isQuickbookConnected } = this.props
    const typeClass = this._getStatusTypeClass(invoice.status)
    const date = new Date(invoice.invoiceDate)
    const dueDate = new Date(invoice.dueDate)
    const _className = classnames(
      'invoice-item',
      {
        nodate: !invoice.invoiceDate && (invoice.imageUrl || !invoice.imageUrl)
      },
      `invoice-item_${typeClass}`
    )
    const bAltInfo = invoice.status === 'Paid' || invoice.status === 'Draft'
    const _colcontClassName = classnames('colcont', {
      imgcont: invoice.imageUrl,
      contentWidth:
        !(invoice.dueDate && invoice.invoiceDate) && !invoice.imageUrl
    })

    let invoiceNumber = invoice.invoiceNo
    let invoiceStatus = Util.getTranslatedStatus(invoice.status)
    if (invoice.status === 'Draft') {
      invoiceNumber = <IntlMessage ident='invoice.list.invoiceNumberDraft' />
      invoiceStatus = 'invoice.list.statusDraft'
    }
    const bShowReminderText = invoice.lastReminderDate
      ? DateUtil.isDateEqual(
          invoice.lastReminderDate,
          DateUtil.getUTCCurrentDate()
        )
      : false

    const bExpand = this.state.bExpand

    return (
      <div className={_className}>
        <div className='cont' onClick={this._onClick.bind(this)}>
          {invoice.dueDate && invoice.invoiceDate && (
            <div className='coldate'>
              <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
              <div className='day'>{DateUtil.getDisplayDay(date)}</div>
              <div className='year'>{DateUtil.getDisplayYear(date)}</div>
            </div>
          )}
          <div className='colsplit' />
          <div className={_colcontClassName}>
            <h2 className='title'>{invoice.title}</h2>
            {!bAltInfo ? (
              <div className='info'>
                <IconButton
                  icon='list-attachment'
                  size='normal'
                  canHover
                  className='subcriptioninfo'
                  onClick={this._onDownload.bind(this)}
                  tooltip='invoice.list.tipDownload'
                  tooltipPosition='top'
                  target='_blank'
                  href={encodeURI(`${this.props.downloadUrl}`)}
                />
                <span className='number'>
                  <IntlMessage ident='invoice.list.invoiceTitle' />{' '}
                  {invoiceNumber}
                </span>
                <span className='split' />
                <span
                  className='project'
                  onClick={this._onClickProject.bind(this, invoice.projectId)}
                >
                  {invoice.project
                    ? (showProjectNumber
                        ? `${invoice.project.projectNumber || '-'} / `
                        : '') + `${invoice.project.title}`
                    : '-'}
                </span>
                {!invoice.isCredit && <span className='split' />}
                {invoice.status === 'Final' && !invoice.isCredit && (
                  <span className='date'>
                    {this._renderFinalizeDate(dueDate)}
                  </span>
                )}
                {invoice.status !== 'Final' && !invoice.isCredit && (
                  <span className='date'>
                    {DateUtil.displayHumanized(invoice.dueDate)}
                  </span>
                )}
                {bShowReminderText && invoice.status === 'Overdue' && (
                  <span className='split' />
                )}
                {bShowReminderText && invoice.status === 'Overdue' && (
                  <span className='date'>
                    <IntlMessage ident='invoice.list.invoiceReminderInfo' />
                  </span>
                )}
              </div>
            ) : (
              <div className='info'>
                <IconButton
                  icon='list-attachment'
                  size='normal'
                  canHover
                  className='subcriptioninfo'
                  onClick={this._onDownload.bind(this)}
                  tooltip='invoice.list.tipDownload'
                  tooltipPosition='top'
                  target='_blank'
                  href={encodeURI(`${this.props.downloadUrl}`)}
                />
                <span className='number'>
                  <IntlMessage ident='invoice.list.invoiceTitle' />{' '}
                  {invoiceNumber}
                </span>
                <span className='split' />
                <span
                  className='project'
                  onClick={this._onClickProject.bind(this, invoice.projectId)}
                >
                  {invoice.project
                    ? (showProjectNumber
                        ? `${invoice.project.projectNumber || '-'} / `
                        : '') + `${invoice.project.title}`
                    : '-'}
                </span>
                <span className='split' />
                <span className='date'>
                  <IntlMessage ident={invoiceStatus} />
                </span>
              </div>
            )}
            {invoice.isRecurring && (
              <span className='recurring'>
                <i className='icon icon-invoice-recurring normal' />
                <i className='icon icon-invoice-recurring-hover hover' />
              </span>
            )}
            {invoice.isLastRecurring && (
              <span className='recurring'>
                <i className='icon icon-invoice-lastrecurring normal' />
                <i className='icon icon-invoice-lastrecurring-hover hover' />
              </span>
            )}
          </div>
          {invoice.imageUrl && (
            <div className='colavatar'>
              <Avatar imageUrl={invoice.imageUrl} />
            </div>
          )}
          <div className='colsplit' />
          <div
            className={`colamount${isQuickbookConnected ? ' hideincl' : ''}`}
          >
            {this.props.bShowReminder &&
              !bShowReminderText &&
              invoice.status === 'Overdue' &&
              !isQuickbookConnected && (
                <IconButton
                  icon='invoice-mailresend'
                  size='big'
                  className='resend'
                  type='error'
                  onClick={this._onResendMail.bind(this)}
                  canHover={false}
                />
              )}
            <h2 className='total'>
              <span className='price'>
                <PriceText value={invoice.total} />
              </span>
            </h2>
            {!isQuickbookConnected && (
              <div className='vatvalue'>
                <IntlMessage ident='invoice.list.vatIncText' />
                &nbsp;
                <PriceText value={invoice.totalInc} />
              </div>
            )}
          </div>
          <div className='expandact' onClick={this._onToggleExpand.bind(this)}>
            <div className='iconcont'>
              <i className='icon icon-grid-expand normal' />
              <i className='icon icon-grid-expand-hover hover' />
            </div>
          </div>
          {bExpand && invoice.activities && invoice.activities.length > 0 && (
            <div className='subitems'>
              {invoice.activities.map((activity, _idx) => {
                if (!activity.items || activity.items.length <= 0) {
                  return null
                }

                return activity.items.map((item, idx) => (
                  <div
                    className={`subitem subitem_${item.status.toLowerCase()}`}
                    key={idx}
                  >
                    <span className='date'>
                      {DateUtil.getDisplayDate(item.activityDate)}
                    </span>
                    <span className='message'>
                      {this._getSubitemMessage(activity, item)}
                    </span>
                  </div>
                ))
              })}
            </div>
          )}
        </div>
        <IconButton
          title='invoice.list.titleSettings'
          icon='common-action-setting'
          size='small'
          onClick={this._onSetting.bind(this)}
        />
      </div>
    )
  }

  _onClickProject (projectId, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    app.changePage('projectview-budget', projectId)
  }

  _onToggleExpand (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this.setState({ bExpand: !this.state.bExpand })
  }

  _getSubitemMessage (activity, item) {
    let messageIdent = ''
    let data = {}

    if (activity.type === 'invoice') {
      messageIdent = `project.view.activity${
        activity.type
      }${item.status.toLowerCase()}`

      if (item.status === 'sendmail') {
        messageIdent = `project.view.activity${activity.type}sendmail`
        if (item.info) {
          data = {
            userName: item.info.userName,
            toEmail: item.info.toEmail
          }
        }
      } else if (item.status === 'resendmail') {
        messageIdent = `project.view.activity${activity.type}resendmail`
        if (item.info) {
          data = {
            userName: item.info.userName,
            toEmail: item.info.toEmail
          }
        }
      } else if (item.status === 'budgetchange') {
        messageIdent = 'project.view.activityPurchaseOrderBudgetChanged'
        data = {
          fromValue: item.info.fromValue || 0,
          toValue: item.info.toValue || 0
        }
      }
    }

    if (!messageIdent) return ''

    return <IntlMessage ident={messageIdent} value={data} />
  }

  _renderFinalizeDate (dueDate) {
    // DueDate is Today or Tommorow show "Due Today"
    const currTime = new Date().getTime()
    const dueTime = dueDate.getTime()
    const dueDays = Math.ceil((dueTime - currTime) / (1000 * 60 * 60 * 24))

    if (dueTime < currTime && dueDays < 2) {
      return DateUtil.displayHumanized(dueDate)
    }

    return `${IntlUtil.convertMessage(
      'invoice.list.invoiceDue'
    )}${DateUtil.getDisplayDay(dueDate)} ${DateUtil.getDisplayFullMonth(
      dueDate
    )}`
  }

  _getStatusTypeClass (status) {
    if (!this.props.isQuickbookConnected) {
      return status.toLowerCase()
    } else {
      return status === 'Draft' ? 'draft' : 'final'
    }
  }

  /* Event Handlers */
  _onClick (event) {
    event.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.invoice)
    }
  }

  _onSetting (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.props.onSetting) {
      this.props.onSetting(this.props.invoice)
    }
  }

  _onResendMail (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onResendMail) {
      this.props.onResendMail(this.props.invoice)
    }
  }

  _onDownload (event) {
    event.stopPropagation()
  }
}

export default InvoiceItem
